export interface Organization {
    employee_id: number;
    company_name: string;
    default_payment?: boolean;
    credit: {
        balance: number;
        valid_until: Date;
        active: boolean;
    };
}

export interface CustomerCreditInfo {
    customerAccountId: number | string;
    customerAccountMonthlyLimit: number;
    defaultPerCustomerAccountMonthlyLimit: number;
    customerAccountMonthlyUsage: number;
    limitAmountPerPurchase: number;
}

export interface TripPurpose {
    id?: number;
    title: string;
    org_id: number;
}

export enum PayerType {
    personal = 'personal',
    company = 'company'
}

export enum CartPaymentStatus {
    locked = 'L',
    cancelled = 'N',
    inShoppingCart = 'S',
    valid = 'Y',
    refund = 'T'
}

export enum TripPurposesTypes {
    other = 'OTHER_PURPOSE'
}
